import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Activity, ActivityService } from "@rubbl-activity";
import { AuthenticationService, EnvironmentConfig } from "@rubbl-core";
import { HowRubblWorksSectionData, MarketingCard } from "@rubbl-marketing";
import { TableUtilsService } from "@rubbl-tables";
import { TableColumn } from "@swimlane/ngx-datatable";

declare var environment: EnvironmentConfig;

@Component({
  selector: "app-renter-dashboard-layout",
  templateUrl: "./renter-dashboard-layout.component.html",
  styleUrls: ["./renter-dashboard-layout.component.scss"],
})
export class RenterDashboardLayoutComponent implements OnInit {
  renterActivities: Activity[] = this.activityService.renterActivities;
  tableFilter: string;
  gettingStartedCards: MarketingCard[] = [
    {
      title: "Complete tasks",
      body: "Be sure to review and complete the tasks below. Some of them are required for account verification and insurance purposes.",
    },
    {
      title: "Find machines",
      body: "<a href='/equipment-rentals/'>Browse live inventory</a> of rent-ready equipment. Filter by category, make, model, attachments, and more.",
    },
    {
      title: "Checkout",
      body: "Configure attachments, enter jobsite location, accept rental terms, and your order is placed. Free cancellations.",
    },
  ];

  renterActions: Activity[] = [
    {
      icon: "icon-question",
      title: "Knowledge base",
      description: "Learn more about being a Rubbl renter.",
      shortDescription: "Learn more about being a Rubbl renter.",
      action: () => {
        window.open("https://support.rubbl.com/renters", "_blank");
      },
    },
    {
      icon: "icon-call",
      title: "Call us",
      description: "Need anything else? Give us a call at (866) 455-8531.",
      shortDescription: "Need anything else? Give us a call at (866) 455-8531.",
      action: () => {
        window.location.href = "tel:(866) 455-8531";
      },
    },
  ] as Activity[];

  columns = [
    { name: "", prop: "photo", pipe: { transform: this.image }, customTemplate: "image", sortable: false },
    { name: "Machines", prop: "itemCount", sortable: false },
    { name: "Rental Request #", prop: "rentalRequestNumber", sortable: false },
    { name: "Date placed", prop: "createdDateTime", pipe: { transform: this.tableUtils.dateTimePipe }, sortable: false },
    { name: "Location", prop: "dropoffLocation", pipe: { transform: this.tableUtils.locationPipe }, sortable: false },
    { name: "Status", prop: "status", customTemplate: "status", sortable: false },
    {
      name: "",
      customTemplate: "actions",
      actions: [
        {
          routerLink: entity => {
            const route = [`/renter/rentals/${entity.id}`];
            return { route };
          },
          label: entity => {
            return "View";
          },
        },
      ],
    },
  ] as TableColumn[];

  constructor(
    private route: ActivatedRoute,
    private activityService: ActivityService,
    private tableUtils: TableUtilsService,
    private authenticationService: AuthenticationService,
  ) {
    const usersAccountId = this.authenticationService.getUserNonAsync().profile.account_id;
    this.tableFilter = `accountId eq '${usersAccountId}' and (status eq 'InProgress' or status eq 'Pending')`;
  }

  ngOnInit(): void {}

  image(image: string[]) {
    return environment.baseImagePath + image;
  }
}
